import { render, staticRenderFns } from "./TextAreaStudy.vue?vue&type=template&id=e15edda8&scoped=true&lang=pug"
import script from "./TextAreaStudy.vue?vue&type=script&lang=ts"
export * from "./TextAreaStudy.vue?vue&type=script&lang=ts"
import style0 from "./TextAreaStudy.vue?vue&type=style&index=0&id=e15edda8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15edda8",
  null
  
)

export default component.exports